import React, { useEffect, useState } from 'react';
import { apiFetch, parseJsonSafe } from '../../utils/api';

const InvoiceWhatsappModal = ({ state, setState, onClose, onSend }) => {
  // Las plantillas se leen de Meta (las que adjuntan documento), no de una lista fija:
  // así las que crees nuevas aparecen aquí solas.
  const [templates, setTemplates] = useState([]);
  const token = localStorage.getItem('token');
  useEffect(() => {
    if (!state.open) return;
    (async () => {
      try {
        const res = await apiFetch('/api/whatsapp/templates?all=1', { headers: { Authorization: `Bearer ${token}` } });
        const data = await parseJsonSafe(res);
        if (Array.isArray(data)) {
          setTemplates(data.filter((t) => t.type === 'waba' && t.mediaHeader === 'DOCUMENT'));
        }
      } catch (_e) { /* si falla, queda el valor por defecto ya seleccionado */ }
    })();
  }, [state.open, token]);
  if (!state.open) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Enviar factura por WhatsApp</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {state.loading ? (
              <p>Cargando datos...</p>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label small">Teléfono *</label>
                  <input
                    className="form-control"
                    value={state.phone}
                    onChange={(e) => setState((prev) => ({ ...prev, phone: e.target.value }))}
                    placeholder="+34 600 000 000"
                    disabled
                  />
                  {!state.phone && (
                    <div className="text-muted small mt-1">
                      El cliente no tiene teléfono principal.
                      {state.clientId && (
                        <>
                          {' '}
                          <a href={'/clientes/' + state.clientId}>Editar cliente</a>
                        </>
                      )}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Razón social</label>
                  <input
                    className="form-control"
                    value={state.clientName}
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Nº de factura</label>
                  <input
                    className="form-control"
                    value={state.invoiceNumber}
                    disabled
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label small">Plantilla</label>
                  <select
                    className="form-select"
                    value={state.templateName}
                    onChange={(e) => setState((prev) => ({ ...prev, templateName: e.target.value }))}
                  >
                    {templates.length === 0 && <option value={state.templateName}>{state.templateName}</option>}
                    {templates.map((t) => (
                      <option key={t.id} value={t.name}>
                        {t.name}{t.variables?.length ? ` (${t.variables.length} var.)` : ''}
                      </option>
                    ))}
                  </select>
                  <div className="form-text">Solo se listan las plantillas de Meta que adjuntan un documento.</div>
                </div>
              </>
            )}
            {state.error && <div className="alert alert-danger py-2 mt-3">{state.error}</div>}
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
            <button
              className="btn btn-success"
              disabled={state.loading || state.sending}
              onClick={onSend}
            >
              {state.sending ? 'Enviando...' : 'Enviar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceWhatsappModal;
